import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getMedia } from 'misc/helpers';
import stampV from 'images/stamp_mask_v.svg';
import stampH from 'images/stamp_mask_h.svg';

class Stamp extends Component {
    render = () => {
        const { version, supportInfo, stampId } = this.props;

        // Default is vertical stamp
        let maskStyle = {
            Mask: 'url(' + stampV + ')',
            MaskImage: 'url(' + stampV + ')',
            WebkitMask: 'url(' + stampV + ')',
            WebkitMaskSize: 'cover'
        };
        let stampImage = getMedia('Stamp_' + stampId + '_' + version);
        let stampClass = '';
        let logoBorderClass = '';

        if (version === 'vertical' && supportInfo && supportInfo.logo) {
            if (this.checkIfImage(supportInfo.logo)) {
                stampImage = supportInfo.logo;
                stampClass = '-logo';
                logoBorderClass = 'logo-border';
                maskStyle = {};
            }
        } else if (version === 'horisontal') {
            maskStyle = {
                Mask: 'url(' + stampH + ')',
                MaskImage: 'url(' + stampH + ')',
                WebkitMask: 'url(' + stampH + ')',
                WebkitMaskSize: 'cover'
            };
        }

        if (version === 'horisontal') {
            stampClass = 'stamp' + stampClass;
        } else {
            stampClass = 'header-stamp' + stampClass;
        }

        let stamp = <img className={stampClass} src={stampImage} style={maskStyle} alt="" />;

        if (version === 'vertical' && supportInfo && supportInfo.url) {
            stamp = (
                <a href={supportInfo.url} className={logoBorderClass} target="_blank">
                    {stamp}
                </a>
            );
        }

        return stamp;
    };

    checkIfImage(url) {
        return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        sessions: state.sessions
    };
};

export default connect(mapStateToProps)(Stamp);



// WEBPACK FOOTER //
// ./src/components/inbox/Stamp.js